import Tippy from "@tippyjs/react";
import './tooltip.module.scss';
export default Tippy;
